import React, { useEffect, useState } from "react";
import styled from "styled-components";
import DownArrow from "../../icons/DownArrow";

const ScrollArrow = (props) => {
  const [showScrollArrow, setShowScrollArrow] = useState(false);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleHeightPosition = () => {
    const pageViewHeight = document.documentElement.scrollHeight;
    const userViewHeight = window.innerHeight;
    const marginBottom = 60;

    if (props.isKeyboardOpen) {
      return setShowScrollArrow(false);
    }

    const isEnoughSpaceToShowArrow =
      pageViewHeight - marginBottom > userViewHeight + window.scrollY;

    setShowScrollArrow(isEnoughSpaceToShowArrow);
  };

  const clearEvents = () => {
    window.removeEventListener("scroll", handleHeightPosition);
    window.removeEventListener("resize", handleHeightPosition);
    setShowScrollArrow(false);
  };

  useEffect(() => {
    handleHeightPosition();
  });

  useEffect(() => {
    window.addEventListener("scroll", handleHeightPosition);
    window.addEventListener("resize", handleHeightPosition);

    return () => clearEvents();
  }, []);

  return (
    <IconContainer
      onClick={scrollToBottom}
      spaceFromBottom={props.spaceFromBottom || 35}
    >
      {showScrollArrow && <DownArrow />}
    </IconContainer>
  );
};

export default ScrollArrow;

const IconContainer = styled.div`
  position: fixed;
  bottom: 35px;
  bottom: ${(props) => `${props.spaceFromBottom}px`};
  right: 15px;
  z-index: 9999;
  cursor: pointer;

  @keyframes moveIcon {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;
